import { render, staticRenderFns } from "./wtInstagramAutoComplete.component.vue?vue&type=template&id=01ffba19&"
import script from "./wtInstagramAutoComplete.component.vue?vue&type=script&lang=js&"
export * from "./wtInstagramAutoComplete.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports